import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";
import ActionTypes from "../../../constants/ActionTypes";
import { apiRequest } from "../api/actions";

const captchaMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  if (action.type.includes(ActionTypes.CAPTCHA.CALL_LAST_REQUEST)) {
    const latestRequest = JSON.parse(localStorage.getItem("latestRequest") ?? '{}');
    next(apiRequest(
      null,
      latestRequest.method,
      latestRequest.url,
      latestRequest.params,
      null,
      latestRequest.entity,
      { 'captcha-value': action.payload }),
    );
  }
};

export default captchaMiddleware;
